import { NgModule } from '@angular/core';
import { TravellerDataTranslationService } from "./traveller-data-translation.service";
import { LabelModule } from "libraries/service/label/label.module";
import { ErrorTracingModule } from "../error-tracing/error-tracing.module";
import { TravellerIdentityPipe } from "./traveller-identity.pipe";
import { TravellerTypePipe } from "libraries/service/traveller-data-translation/traveller-type.pipe";
import { TravellerGenderIconPipe } from "libraries/service/traveller-data-translation/traveller-gender-icon.pipe";

@NgModule({
    imports: [
        LabelModule,
        ErrorTracingModule,
    ],
    providers: [
        TravellerDataTranslationService
    ],
    declarations: [
        TravellerIdentityPipe,
        TravellerTypePipe,
        TravellerGenderIconPipe
    ],
    exports: [
        TravellerIdentityPipe,
        TravellerTypePipe,
        TravellerGenderIconPipe
    ]
})
export class TravellerDataTranslationModule { }
